<template>
  <div class="mb-2 sub-menu">
    <b-button
      :id="menu.routeName"
      :variant="
        $route.meta.navActiveTab == menu.active ? `primary` : `outline-primary`
      "
      v-for="menu in menus"
      :key="`menu-${menu.routeName}`"
      class="mr-1"
      @click="
        $router.push({ name: menu.routeName, params: { id: $route.params.id } })
      "
    >
      {{ $t(menu.label) }}
    </b-button>
  </div>
</template>

<script>
import { BButton } from "bootstrap-vue";

export default {
  components: {
    BButton,
  },
  data() {
    return {
      menus: [
        {
          routeName: "update-agent",
          active: "update-agent",
          label: "breadcrumb.updateAgent",
        },
        {
          routeName: "list-agent-block-number",
          active: "agent-block-number",
          label: "breadcrumb.blockNumber",
        },
        {
          routeName: "list-agent-allow-number",
          active: "agent-allow-number",
          label: "breadcrumb.allowNumber",
        },
        {
          routeName: "list-agent-sell-out",
          active: "agent-sell-out",
          label: "breadcrumb.sellOut",
        },
        {
          routeName: "list-agent-bet-setting",
          active: "agent-bet-setting",
          label: "breadcrumb.betSetting",
        },
      ],
    };
  },
  mounted() {
    this.scrollToMenu();
  },
  methods: {
    scrollToMenu() {
      setTimeout(() => {
        const element = document.getElementById(this.$route.name);
        element.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }, 200);
    },
  },
  setup() {},
};
</script>